import { i18n } from '@fs/zion-locale'

export default {
  textFieldPlaceholder: () => i18n.t('LanguagePicker.auotsuggestFieldPlaceholder', 'Add a language'),
  errorMessage: () => 18n.t('LanguagePicker,errorMessage', 'This field did not save correctly.'),
}
